import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { BestellungPosition, deleteBestellungPosition } from 'api/bestellungPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface BestellungPositionDeleteProps {
    bestellungPosition: BestellungPosition;
    onClose: (refetch: boolean) => void;
}

export const BestellungPositionDelete: React.FC<BestellungPositionDeleteProps> = ({ bestellungPosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (bestellungPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteBestellungPosition(bestellungPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Bestellposition löschen',
                subText: 'Bestellposition "' + bestellungPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
